const NAVIGABLE_PROTOCOLS: string[] = ['http:', 'https:'];

/** Whether the browser may be sent to this address: a web address only, so that nothing like `javascript:` can run from a response. */
export const isSafeNavigationUrl = (url: string): boolean => {
  try {
    return NAVIGABLE_PROTOCOLS.includes(new URL(url).protocol);
  } catch {
    return false;
  }
};
